import React, { Component } from 'react'

import Config from '.././config/Config';
import Cache from '.././frame/Cache';
import WidgetAjax from '.././widget/WidgetAjax';

import WidgetTable from '.././widget/WidgetTable';
import WidgetSelect from '.././widget/WidgetSelect';
import WidgetTreePicker from '.././widget/WidgetTreePicker';
import WidgetMareting from './WidgetMareting'

import WidgetMessage from '.././widget/WidgetMessage';


import { Form } from 'antd';
import { Input } from 'rsuite';


class WidgetVertical extends Component {

    constructor(props){
        super(props);


        this.state = {
            basePath:Config.getBasePath(),
            options : {
                // 数据条数
                records : 10
            },
            columns:[
                { name: 'entid', title: '企业id', type: 'string', description: '企业id', properties: { hidden: true }},
                { name: 'inEntName', title: '合作企业', type: 'string', description: '合作企业', properties: { hidden: false }},
                { name: 'entName', title: '合作企业', type: 'string', description: '合作企业', properties: { hidden: false }},
                { name: 'relateType', title: '关联类型', type: 'string', description: '营销类型', properties: { hidden: false, transform: "transformRelateType"}},
                { name: '"recommendation', title: '推荐度', type: 'string', description: '推荐度', properties: { hidden: false, transform: "transformRecommendation" }},
                { name: 'industry', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false }},
                { name: 'region', title: '所在地区', type: 'string', description: '所在地区', properties: { hidden: false }},
                { name: 'tel', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false }},
                { name: 'entStatus', title: '企业状态', type: 'string', description: '企业状态', properties: { hidden: false, transform: "transformENTSTATUS" }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            { name: '添加监控', click: "marketingAddMonitor" },
                            { name: '添加CRM', click: "marketingAddCRM" }
                        ],
                        transform: "transformOperations"
                    }
                },
              
            ],
            selectoptions:{
                cleanable : true,
            },
            userStatusData: [
                {label:'不限', value:'0'},
                {label:'工商关系', value:'1'},
                {label:'关联关系', value:'2'}
            ],
            groupData: [
                {label:'不限', value:'0'},
                {label:'极为推荐', value:'1'},
                {label:'较为推荐', value:'2'},
                {label:'不推荐', value:'3'}
            ],
            industryData:[],
            conditionData:[
                {label:'不限', value:'0'},
                {label:'预付费', value:'1'},
                {label:'后付费', value:'2'}
            ],
            state : undefined, 
            group : undefined, 
            industry:undefined,
            condition:undefined,
            departmentTreeoptions : {
                title:"",
                type : 'select'
            },
            keyWord : undefined,
            parentDepartmentData:[],
            titleData:[],
            data:undefined,
            total:0,
            messageOptions: {
                title: '添加监管'
            },
        }
        this.paramsChange=this.paramsChange.bind(this);
        this.parentDepartmentOnSelect=this.parentDepartmentOnSelect.bind(this);
        this.loadDepartmentInfo = this.loadDepartmentInfo.bind(this);
        this.onLoadDepartmentInfo = this.onLoadDepartmentInfo.bind(this);
       
        
        this.onRelationSearch = this.onRelationSearch.bind(this);
        this.onLoadRelationSearch = this.onLoadRelationSearch.bind(this);

        this.buildData = this.buildData.bind(this);
        this.buildFilterData = this.buildFilterData.bind(this);

        this.onIndustryData = this.onIndustryData.bind(this)
        this.onIndustryDataInfo = this.onIndustryDataInfo.bind(this)

        this.onConditionData = this.onConditionData.bind(this)
        this.onConditionDataInfo = this.onConditionDataInfo.bind(this)

        this.marketingAddMonitor = this.marketingAddMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.marketingAddCRM = this.marketingAddCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);

        this.transformRelateType = this.transformRelateType.bind(this);
        this.transformOperations = this.transformOperations.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this)
        
        this.transformRecommendation = this.transformRecommendation.bind(this)

        this.transformENTSTATUS = this.transformENTSTATUS.bind(this)

    }

    componentDidMount()
    {
        this.loadDepartmentInfo();
        // this.searchEvents();
        this.onIndustryData();
        this.onConditionData();
    }

    setMessageRef = (ref) => {
        this.messageRef = ref;
    }

    componentWillReceiveProps(nextProps)
    {
        if(this.state.keyWord != nextProps)
        {
            this.setState({
                keyWord:nextProps.searchInputValue
            });

            this.onRelationSearch(nextProps.searchInputValue)
        }
    }

     /**
     * 表格事件函数
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @param {*} tableData
     * @returns 
     */
      tableOnEvent(type, data, value, event,tableData) 
      {
          switch (type) 
          {
              case "marketingAddMonitor":
              {
                  data = JSON.parse(data);
  
                  this.marketingAddMonitor(data);
  
                  break;
              }
              case "marketingAddCRM":
              {
                  data = JSON.parse(data);
                  this.marketingAddCRM(data);
                  break;
              }
              case "transformOperations":
              {
                  return this.transformOperations(data, value);
              }
              case "transformRelateType":
              {
                  return this.transformRelateType(data, value);
              }
              case "transformRecommendation":
              {
                  return this.transformRecommendation(data,value)
              }
              case "transformENTSTATUS":
              {
                  return this.transformENTSTATUS(data,value)
              }
              default:
                  break;
          }
      }


      /**
     * 操作格式化
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
     transformOperations(data, content) 
     {
         if (content.props !== undefined && content.props.children !== undefined) 
         {
             for (let i = 0; i < content.props.children.length; i++) 
             {
 
                 let child = content.props.children[i];
 
                 if (child.props.className === "marketingAddMonitor") 
                 {
                     if (data.MONITOR === true) {
                         content.props.children.splice(i, 1);
                         i--;
                     }
                 }
                 else if (child.props.className === "addCRM") 
                 {
                     if (data.CRM === true) 
                     {
                         content.props.children.splice(i, 1);
                         i--;
                     }
                 }
             }
         }
 
         return content;
     }
     /**
     * 添加监管
     * @param {*} data 
     */
      marketingAddMonitor(data) 
      {
  
          let { messageOptions } = this.state;
  
          messageOptions["isMessage"] = false;
  
          messageOptions['confirmFunction'] = this.addMonitorConfirm;
  
          messageOptions["message"] = `确定要把 '` + data.entName + `' 添加到监管对象中吗?`;
  
          messageOptions["title"] = "添加监管";
  
          this.state['messageOptions'] = messageOptions;
  
          this.state['entityData'] = data;
  
          this.messageRef.open();
  
      }
  
      addMonitorConfirm() 
      {
          const { basePath, entityData, isBatch, checkData } = this.state;
  
          let params = {};
  
          if (isBatch === true)
           {
              let ENTIDs = [];
  
              for (let item of checkData) 
              {
                  ENTIDs.push(item.entid);
              }
  
              params["ENTIDs"] = ENTIDs;
          }
          else 
          {
              params["ENTID"] = entityData.entid;
          }
  
          WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
      }

      onAddMonitor(result, params, backParam) 
      {
          if (result.status === 0) 
          {
              let { messageOptions, isBatch, checkData } = this.state;
  
              messageOptions["isMessage"] = true;
  
              if (isBatch === true) 
              {
                  let ENTNAMEs = "", isFirst = true;
  
                  for (let item of checkData) 
                  {
                      if (isFirst === true) 
                      {
                          ENTNAMEs = `'` + item.entName + `'`
  
                          isFirst = false;
                      }
                      else 
                      {
                          ENTNAMEs += `, '` + item.entName + `'`
                      }
                  }
  
                  if (result.result === checkData.length) 
                  {
                      messageOptions["message"] = ENTNAMEs + `' 全部成功加入监控对象中!`;
                      setTimeout(() => { this.props.history.go() }, 1500)
                  }
                  else 
                  {
                      messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功添加监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                      setTimeout(() => { this.props.history.go() }, 1500)
                  }
              }
              else 
              {
                  messageOptions["message"] = backParam["data"].entName + `' 已成功添加进监控对象中!`;
                //   this.search(1);
              }
  
              messageOptions["title"] = "添加监控";
  
              this.state['entityData'] = undefined;
              this.state['checkData'] = [];
              this.state['messageOptions'] = messageOptions;
  
              this.messageRef.open();
          }
          else if (result.status === 10) 
          {
              Cache.logout(this.props);
          }
  
      }

      transformRelateType(data, value )
      {
          switch(data.relateType)
          {
              case "0" :
              {
                  return "无";
              }
              case "1" :
              {
                  return "工商";
              }
              case "1-1":
              {

                  return "股东(企业)";
              }
              case "1-2":
              {
                  return "企业对外投资";
              }
              case "1-3":
              {
                  return "法人对外投资";
              }
              case "1-4":
              {
                  return "法人对外任职";
              }
              case "1-5":
              {
                  return "股东(自然人)对外投资";
              }
              case "1-6":
              {
                  return "股东(自然人)对外任职";
              }
              case "2":
              {
                  return "交易";
              }
              case "2-1":
              {
                  return "关联关系";
              }
              default:
              {
                  return "无"
              }
          }
      }

      transformRecommendation(data,value)
      {
          if(data.recommendation >= 160)
          {
            return <span className="jolly">极为推荐</span>
          }
          else if(data.recommendation >= 80 && data.recommendation < 160)
          {
            return <span className="relatively">较为推荐</span>
          }
          else
          {
            return <span className="notRecommend">不推荐</span>
          }
      }
  
      transformENTSTATUS(data,value)
      {
          switch(data.entStatus)
          {
              case "1" :
              {
                  return "存续(在营、开业、在册)";
              }
              case "2" :
              {
                  return "吊销，未注销";
              }
              case "3":
              {
                  return "吊销，已注销";
              }
              case "4":
              {
                  return "注销";
              }
              case "5":
              {
                  return "撤销";
              }
              case "6":
              {
                  return "迁出";
              }
              default:
              {
                  return "其他"
              }
          }
      }


       /**
     * 添加 CRM
     * @param {*} data 
     */
        marketingAddCRM(data) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = false;
            messageOptions["message"] = `确定要把 '` + data.entName + `' 添加至CRM中吗?`;
            messageOptions['confirmFunction'] = this.addCRMConfirm;
            messageOptions["title"] = "添加CRM";
            messageOptions["entData"] = data
    
            this.state['messageOptions'] = messageOptions;
    
            this.messageRef.open();
        }
    
        addCRMConfirm() 
        {
            let { messageOptions, basePath, isBatch, checkData } = this.state, params;
    
            if (isBatch === true) 
            {
                let ENTIDs = [];
    
                for (let item of checkData) 
                {
                    ENTIDs.push(item.entid);
                }
    
                params = {
                    "ENTIDs": ENTIDs
                }
    
                WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { checkData } });
            }
            else 
            {
                let data = messageOptions["entData"];
    
                params = {
                    "ENTID": data["entid"]
                };
    
                WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.entName } });
            }
        }
    
        onAddCRM(result, params, backParam) 
        {
            if (result.status === 0) 
            {
                if (backParam.checkData) 
                {
                    let { messageOptions } = this.state, isFirst = true, addCRMName = '';
    
                    messageOptions["isMessage"] = true;
    
                    for (let item in backParam.checkData) 
                    {
                        if (isFirst) 
                        {
                            addCRMName = backParam.checkData[item].entName
                            isFirst = false
                        }
                        else 
                        {
                            addCRMName += ", " + backParam.checkData[item].entName
                        }
                    }
                    
                    messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!`;
                    messageOptions["title"] = "添加成功";
                    this.state['messageOptions'] = messageOptions;
                }
                else 
                {
                    let { messageOptions } = this.state;
                    messageOptions["isMessage"] = true;
                    messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
                    messageOptions["title"] = "添加成功";
                    this.state['messageOptions'] = messageOptions;
                }
    
                this.messageRef.open();
            }
            else if (result === 10) 
            {
                Cache.logout(this.props);
            }
            else if (result.status === -1) 
            {
                let { messageOptions } = this.state;
                messageOptions["isMessage"] = true;
                messageOptions["message"] = `发生错误，添加失败!`;
                messageOptions["title"] = "错误";
                this.state['messageOptions'] = messageOptions;
    
                this.messageRef.open();
            }
    
            this.state["isBatch"] = false
        }

    onRelationSearch( )
    {
        
        let { basePath,data, state, keyWord, group, industry, condition, parentDepartmentId } = this.state;
        let {entValue} = this.props

        let params = {
            ENTNAME:entValue
        }

        if(group!==null&&group!==undefined&&group!==""){
            params["RECOMMENDATION"]=group
        }

        if(industry!==null&&industry!==undefined&&industry!==""){
            params["INDUSTRY"]=industry
        }

        if(state!==null&&state!==undefined&&state!==""){
            params["state"]=state
        }

        if(parentDepartmentId!==null&&parentDepartmentId!==undefined&&parentDepartmentId!==""){
            params["LOCATION"]=parentDepartmentId
        }

        if(condition!==null&&condition!==undefined&&condition!==""){
            params["ENTSTATUS"]=condition
        }

        WidgetAjax.ajax({url:basePath + '/entity/relation', params:params, callback:this.onLoadRelationSearch}); 
    }

    onLoadRelationSearch( result )
    {
        if (result.status === 0) 
        {
            if(result.results.length===1 && result.results[0]===null )
            {
                this.setState({data:[]});
            }
            else
            {     
                this.setState({data:result.results,total:result.total});
            }
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    
    //"dimension":{"code":"D140001", "hierarchy":4}
    loadDepartmentInfo()
    {
        const { basePath } = this.state;

        let params = {
            "dimension":{"code":"D111001", "hierarchy":4}
        }

        WidgetAjax.ajax({url:basePath + '/widget/dimension', params:params, callback:this.onLoadDepartmentInfo});
    }

    onLoadDepartmentInfo(result, params )
    {
        if( result.status===0 )
        {
            let departmentData = this.buildData(result.results, -1);

            this.setState({parentDepartmentData:departmentData["D111001"]});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    onIndustryData()
    {
        const { basePath } = this.state;

        let params = {
            "dimension":{"code":"D140001", "hierarchy":4}
        }

        WidgetAjax.ajax({url:basePath + '/widget/dimension', params:params, callback:this.onIndustryDataInfo});
    }

    onIndustryDataInfo(result)
    {
        if( result.status===0 )
        {
            let industryData = this.buildData(result.results, -1);

            this.setState({industryData:industryData["D140001"]});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    onConditionData()
    {
        const { basePath } = this.state;

        let params = {
            "dimension":{"code":"D143"}
        }

        WidgetAjax.ajax({url:basePath + '/widget/dimension', params:params, callback:this.onConditionDataInfo});
    }

    onConditionDataInfo(result)
    {
        if( result.status===0 )
        {
            let conditionData = this.buildData(result.results, -1);

            this.setState({conditionData:conditionData["D143"]});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    
    
    /** 创建 filter data */
    buildData(results, parent)
    {
        let result = {};
        
        if( results!==undefined && results.length>0 )
        {
            for( let j in results)
            {
                let data = results[j];

                let items = this.buildFilterData(data, parent);

                result[results[j].code] =  items; 
            } 
        }

        return result;
    }

    buildFilterData( data, parent)
    {
        let items = [];

        for( let i=0; i<data.values.length; i++ )
        {
            let node = {};
            
            node.role = parent;
            node.label = data.values[i].name;
            node.code = data.code;

            node.value = data.values[i].value;

            if( data.values[i]!==undefined && data.values[i].subdimension !== undefined && data.values[i].subdimension.values.length > 0 )
            {
                node.children = this.buildFilterData(data.values[i].subdimension, data.values[i].value);
            }
            
            items.push(node);
        }

        return items;
    }


    /**
     * 上级部门选择
     * @param {*} values 
     */
     parentDepartmentOnSelect( values )
     {
         
         if(values.length === 0)
         {
             this.state["parentDepartmentId"] = undefined;
             return null;
         }
 
         if( values!==undefined && values.length ===1 )
         {
             this.state["parentDepartmentId"] = values[0];
         }
     }
 
     paramsChange(value,type)
     {
         switch( type )
         {
             case 'type':
             {
                 // this.setState({typeValue:value})
                 this.state["typeValue"] = value;
                 break;
             }
             case 'state':
             {
                 // this.setState({state:value})
                 this.state["state"] = value;
                 break;
             }
             case 'keyWord':
             {
                 this.setState({keyWord:value})
                 break;
             }
             case 'group':
             {
                 // this.setState({group:value})
                 this.state["group"] = value;
                 break;
             }
             case  "condition":
             {
                 this.state["condition"] = value;
                 break;
             }
             case "industry":
            {
                this.state["industry"] = value
            }
             default:
                 break;
         }
     }



    render() {
        let {  options, enterpriseName,
            selectoptions,userStatusData,state,groupData,group,departmentTreeoptions,total,messageOptions,
            keyWord,parentDepartmentData,parentDepartmentId, industryData,industry,conditionData,condition,data,columns
        } = this.state
        return (
            <div>
                <div className="marketing-content" style={{height:'auto', paddingBottom: 0}} >
                    <div className="content-canvas content-top-frame-height height-100 content-height" style={{borderRadius:"1px",boxShadow:"none"}}>
                    <div className="maretingSelectTime">
                            <div className="maretingSelectLog">
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="营销类型" className="aaa">
                                        <WidgetSelect options={selectoptions} data={userStatusData} onSelect={(value)=>this.paramsChange(value,'state')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="企业状态">
                                        <WidgetSelect options={selectoptions} data={conditionData} onSelect={(value)=>this.paramsChange(value,'condition')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="合作企业">
                                        <div style={{width: '359px', margin:'5px -6px', float: 'left', borderRadius:"0px",paddingLeft:"15px"}} >
                                            <Input onChange={(value) => {this.paramsChange(value, 'keyWord')}} placeholder="合作企业名称" value={keyWord}></Input>
                                        </div>
                                    </Form.Item>
                                </div>
                            </div>

                            <div className="maretingSelectLog"> 
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="推荐度" >
                                        <WidgetSelect options={selectoptions} data={groupData} onSelect={(value)=>this.paramsChange(value,'group')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div> 
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="行业类型">
                                        <WidgetSelect options={selectoptions} data={industryData} onSelect={(value)=>this.paramsChange(value,'industry')} defaultValue={"0"} ></WidgetSelect>
                                    </Form.Item>
                                </div>
                                
                            </div>
                            <div className="maretingSelectLog">
                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="所在地区">
                                        <WidgetTreePicker options={departmentTreeoptions} data={parentDepartmentData} defaultValues={[parentDepartmentId]}
                                            onSelect={this.parentDepartmentOnSelect}></WidgetTreePicker>
                                    </Form.Item>
                                </div>

                                <div className='maretingSelectLog-item'>
                                    <Form.Item label="输入企业">
                                        <div style={{width: '359px', margin:'5px -6px', float: 'left', borderRadius:"0px",paddingLeft:"15px"}} >
                                            <Input onChange={(value) => {this.paramsChange(value, 'keyWord')}} placeholder="输入企业名称" value={keyWord}></Input>
                                        </div>
                                    </Form.Item>
                                    
                                </div>
                               
                                
                            </div>
                            
                        </div> 

                        <div className="selectStates" style={{border:"none"}}>
                            <button className="querys click" onClick={()=>this.onRelationSearch("keyWord")} >确定</button>
                            <button className="clears click" onClick={this.props.backMarKeting}>取消</button>
                        </div>
                    </div>
                </div>
                
                <div className="dataLength">为您找到<span>{total}</span>条记录</div>
                <div className="marketing-table" >
                    <WidgetTable options={options} columns={columns} data={data} 
                    // total={total} 
                    notify={this.tableOnEvent} 
                    // pageTurning = {this.pageTurning}
                    ></WidgetTable>
                </div>

                <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />
            </div> 
        )
    }
}

export default WidgetVertical
